import React from "react";
import { Axis, Bar, Legend, LegendItem, Note, Plot, Root, VisuallyHidden } from "./DurationBars.styles";
import type { DurationBarsProps } from "./DurationBars.types";

const MIN_HEIGHT_PCT = 6;

/** A row of vertical bars, one per run, tall by duration and coloured by outcome. Stateless. */
export const DurationBars: React.FC<DurationBarsProps> = ({
  items,
  ariaLabel,
  startLabel,
  endLabel,
  caption,
  legend,
  note,
  heightRem = 4.5,
  className,
}) => {
  const tallest = Math.max(0, ...items.map((item) => item.value));
  return (
    <Root className={className}>
      <Plot $heightRem={heightRem} role="list" aria-label={ariaLabel}>
        {items.map((item) => (
          <Bar
            key={item.id}
            $tone={item.tone}
            $heightPct={tallest > 0 ? Math.max(MIN_HEIGHT_PCT, (item.value / tallest) * 100) : MIN_HEIGHT_PCT}
            title={item.label}
          >
            <VisuallyHidden>{item.label}</VisuallyHidden>
          </Bar>
        ))}
      </Plot>
      {startLabel || endLabel || caption ? (
        <Axis>
          <span>{startLabel}</span>
          <span>{caption}</span>
          <span>{endLabel}</span>
        </Axis>
      ) : null}
      {legend?.length ? (
        <Legend aria-label="Key">
          {legend.map((entry) => (
            <LegendItem key={entry.tone} $tone={entry.tone}>
              {entry.label}
            </LegendItem>
          ))}
        </Legend>
      ) : null}
      {note ? <Note role="status">{note}</Note> : null}
    </Root>
  );
};

export default DurationBars;
